const Locale = {
  document_title: "Orders panel - QRWaiter",
  choose_language: "Choose language:",
  login: {
    title: "Enter order queue",
    enter_qid_pin: "Enter qID of place and your PIN-code",
    enter_pin: "PIN-code",
    qid_ph: 'Place ID',
    enter_shared: "Shared queue",
  },
  navbar: {
    queue: "Order queue",
    archive: "Order history",
    tables: "Halls and tables",
    orders: "Orders",
    notifs: "Notifications",
    stoplist: 'Stop-list',
    support: "Technical support",
    switch_new: 'Switch to new version',

    logout_confirm: "Are you sure you want to log out?",
    logout: "Logout",
  },
  queue: {
    connecting_title: "Connecting, please wait...",
    connecting_desc:
      "If connection takes too long - please try again later or contact tech support",
    create_order: "Create new order",
    no_orders: "No orders in this tab yet",
    check_history: "Show history",
    creating_order_message: "Creating new order",

    shared_queue: "Shared queue",
    not_your_order: "This is not your order, so this action cannot be done.",
    modes_not_setup:
      "To get access to orders queue, setup desired modes in admin panel.",
  },
  tabs: {
    new: "New",
    processing: "In progress",
    done: "Paid",
    calendar: "Calendar",
  },
  card: {
    client: "Client:",
    total: "Total:",
    comment: "Comment:",
    discount: "Discount:",
    pay_method: "Payment method:",
    reason: 'Cancel reason:',

    append: 'Additional order',
    append_accepted_at: 'Was accepted',
    append_accepted_now: 'Was accepted just now',

    pay_methods: {
      cash: "Cash",
      card: "Terminal",
      online: "Online",
      bonus: "Bonuses",
    },

    descriptions: {
      waiting: "New order waits:",
      serving: "Serving:",
      serving_timer: "To serve:",
      served: "Served",
      paying: "Unpaid...",
      executed: "Paid.",
      editing: "Editing",
    },

    geolocation_not_verified: 'Warning! This order did not pass geolocation check.',

    pay_status: "Payment status:",
    paid: "Paid",
    unpaid: "Unpaid",

    to_pay: "To pay:",
  },
  waiting: {
    title: "Choose cooking time",
    title_hotel: 'Choose waiting time',
    time: "min",
    hours: 'h',
    not_required: "Cooking time is not required",
    exact_time: 'Specify exact time'
  },
  status: {
    table_no: "Table",
    hall: "Hall",
    room: 'Room',
  },
  actions: {
    accept: "Accept",
    cancel: "Deny",
    pay: "Confirm payment",
    edit: "Edit order",
    move: "Move clients to another table",
    options: "Options",

    split: "Split check",
    merge: `Merge check`,
    close: "Close check",
    unlock: "Unlock",
    return: "Cancel payment",
    add_dish: "Add dish",
    serve: "Served",
    self_serve: 'Ready',

    to_inside: "Convert to INSIDE",

    unlock_desc1: "Client is paying for check online",
    unlock_desc2: "Check will be closed automaticaly.",

    preorder_accept: "Accept",
    preorder_served: "Served",
    preorder_sent: "Sent",
  },

  pay: {
    set_discount: "Set discount:",
    by_cash: "Cash",
    by_card: "Card",
  },

  add_dish: {
    title: "Choose the dish:",
    choose_modificators: "Choose addtions:",
    choose_variant: "Choose variant:",
    add_to_cart: "Add to cart",
    add_many: "Check",
    go_to_cart: "Go to check",
    dishes_count: "dish | dishes",

    back: "Back",
    add: "Add",
  },

  choose_table: {
    title: "Choose table:",
    accept: "Choose table",
    small_hint: 'Choose table',
  },

  edit: {
    title: "Edit check",
    add_dish: "Add dish",

    cancel: "Cancel",
    save: "Save",
  },

  merge: {
    title: `Checks merge:`,
    cancel: "Cancel",
    confirm: `Merge`,
  },

  refuse: {
    title_some: "You refuse to serve client {amount} dish(es)",
    title_all: "You refuse to server client all the dishes",

    enter_reason: "Choose reason:",

    enter_reason_ph: "Input reason",

    reasons: {
      stock: "Dish(es) are not present",
      age: "The sale of alcohol to people under 18 is forbidden",
      custom: "Other",
    },

    delete_reason: "Waiter deleted check.",

    refund_warning: 'Warning: cancelling order will result in refund of client\'s funds according to payment system policy.',

    cancel: "Return",
    confirm: "Cancel order",
  },

  split: {
    title: "Split check",
    cancel: "Cancel",
    confirm: "Confirm",
  },

  create_order: {
    confirm: "Create order",
    cart: 'Cart',
    choose_dish: 'Select dish',
    check_order: 'Check order validity',
  },

  archive: {
    tabs: {
      cash: "Cash",
      card: "Terminal",
      online: "Online",
    },
    modes: {
      list: "History",
      summary: "Summary",
    },
    no_checks: "No checks with this payment method yet.",
    pay_method: "Payment method:",

    summary: {
      total: "Total:",
      discount: "Discount summary:",
      tips: "Tips:",
    },
  },

  tables: {
    loading: "Loading...",
    loading_text: "Our desighners are drawing table grid, please wait...",

    table_no: "Table №",

    titles: {
      move: "Move to:",
      join: `Merge with:`,
    },

    actions: {
      merge: `Merge checks`,
      join: `Merge tables`,
      disjoin: `Split tables`,
      move: "Move to another tables",
      join_empty: `Merge tables`,
    },

    action_messages: {
      merge: "Merging tables",
      merge_description: "Select a table, you want to merge with",
      move: "Check moving",
      move_description: "Select a new table for the current check",
    },

    confirm: {
      move: "Move to another table",
      join: `Merge`,
    },

    table_empty: "Empty",

    noun_checks: {
      singular: "Check",
      plural: "Checks",
      plural_2: "Checks",
    },
  },
  friendly_dates: {
    today: 'Today',
    tomorrow: 'Tomorrow'
  },
  create_preorder: {
    name_ph: `Name`,
    address_ph: 'Address',
    asap: 'As soon as possible',
    date_ph: 'Choose date and time',
    no_guests: 'Utensils-free',
    payment_ph: 'Payment',
    payment_cash: 'Cash',
    payment_card: 'Card',
    to_order: 'Go to order',
    comment_ph: 'You can leave comment for the order.',
    takeaway: 'Takeaway',
    with_reservation: '+ table reservation',

    fill_fields: 'Fill in all fields.',
    create_btn: 'Create order',

    details_types: {
      flat: 'Flat',
      floor: 'Floor',
      entrance: `Entrance`
    },

    bonus_balance: 'BONUS BALANCE'
  },
  preorder_card: {
    phone: "Phone:",
    takeaway: "Client wants to receive order at:",
    date: "Date:",
    address: "Address:",
    serve_date: "Serve by:",
    time: "Time:",

    serve_plus: "in",
    serve_minus: "ago",
    action_cancel: "Cancelled",
    action_edit: 'Edit',

    wait_limit: "You have 15 minutes to accept the order.",
    send_desc: "Mark order as sent, and the guest will receive a notification",
    delivery_autoclose:
      "Check will be closed automatically, after delivery is done.",
    preorder_autoclose: "Check will be closed in 30 seconds.",

    action_close: "Close order",

    takeaway_warning:
      "Attention! This is order for future, check receive time.",
    paid_by_bonuses: "This order was paid with bonuses.",

    with_takeaway: "Takeaway",
    with_reservation: "+ table reservation",

    delivery_cost: "+ Delivery",
    delivery_cost_taxi: "+ Delivery, which is paid upon receiving",
  },
  delivery_order_car: {
    title: "Car will be in:",
    action: "Order car",
  },
  delivery_driver: {
    title: "Driver information:",
    phone: "Phone:",
    car: "Car number:",
    warning:'Not a single driver accepted the order. Delivery dispatcher phone:'
  },
  errors: {
    title:
      "An error occured. Please, reload the page or re-login to order queue.",
    codes: {},
  },
  reserve: {
    header: "Table reservation",
    card_guests_count: "person | people",
    card_reserve_time: "Reservation time:",
    card_reserve_date: "Reservation date:",
    card_phone: "Phone number:",
    card_accept: "Accept",
    card_cancel: 'Cancel reservation',
    card_accepted: 'Table reserved, you will also receive a notification.',
  },
  units: {
    guests: "kit | kits",
    reserve_guests: 'person | people',
    kg: 'kg',
    g: 'g',
    l: 'l',
    ml: 'ml'
  },
  reserve_calendar: {
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow'
  },
  preorder_status_bar: {
    accept_desc: "To accept order",
    serve_desc: "Until serving",
    accept_local: "Waits confirmation",
    send_desc: "Until sending",
    pay_status: "Payment status",
    paid: "Paid",
    unpaid: "Unpaid",
    served: "Served",
    sent: "Sent",
    creating: 'Creating...'
  },
  inside_status_bar: {
    accept_desc: "Waits confirmation",
    serve_desc: "Until serving",
    served: "Served",
    serving: "Serving...",
    splitting: "Check splitting...",
    editing: "Editing...",
  },
  logout: {
    confirm: "Are you sure you want to logout?",
  },
  item_list: {
    weight_input: 'Weight'
  },
  delete_dish: {
    title: 'Delete dish?',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  stoplist: {
    tab_editor: 'MENU',
    tab_stoplist: 'STOP-LIST',
    search_ph: 'Search...',

    type_dish: 'Dish',

    stoplisted: 'Added to stoplist'
  }
};

export default Locale;
